import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewChecked, AfterViewInit, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { ExpenseService } from '../../../service/expense/expense.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { SalesGroupOwnerService } from '../../../service/sales-group-owner/sales-group-owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa8013',
  templateUrl: 'wa8013.component.html',
  styleUrls: ['wa8013.component.scss']
})
export class Wa8013Component implements AfterViewInit, OnChanges {
  public componentTitle = 'WA8013:諸掛一括登録';

  // drop down list
  public owners: any;
  public salesgroups: any;
  public salesgroupowners: any;

  // detail
  public details: [Detail];
  public validation = validation;
  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  public onSubmitActive = 'disabled';
  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;
  public ownerId: number;
  public ownerResult: any;
  private allowner: boolean = false;
  @ViewChild('scrollContent')
  scrollContent: ElementRef;
  @ViewChild('pcsNr')
  pcsNr: ElementRef;
  //SW-1872
  @ViewChild('UnitpricedispNrForm')
  UnitpricedispNrForm: ElementRef;
  private salectowners;
  @Input() ownerchanges
  public ownerTx: string;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private expenseService: ExpenseService,
    private ownerService: OwnerService,
    private salesGroupOwnerService: SalesGroupOwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.details = [new Detail(this.ownerService, this.salesGroupOwnerService, this.commonService, this.dialogsService)];
    this.details.forEach(v => {
      v.caller = this;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.ownerchange();
    }, 500);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  deleteExpense(idx) {
    this.errorInfo = '';

    if (this.details.length === 1 && idx === 0) {
      this.errorInfo = validation.message.delete.detail;
      return;
    }
    this.details.splice(idx, 1);
  }

  addDetail() {
    let errors = false;
    let countNr = 0;
    let rowmassegeTx = '';
    for (const detail of this.details) {
      countNr += 1;
      rowmassegeTx = '(明細' + countNr.toString() + ')';
      var selectedOnwerdisplayTx = detail.owners.filter((item, index) => {
        if (item.ownerdisplayTx === detail.ownerdisplayTx.value.trim()) return true;
      });
      if (selectedOnwerdisplayTx.length === 0) {
        detail.ownerdisplayTx.enable({ onlySelf: true });
        detail.ownerdisplayTx.markAsTouched({ onlySelf: true });
        errors = true;
        this.errorInfo = validation.message.onwer + rowmassegeTx;
        return;
      }
      var selectedSalesgroupdisplayTx = detail.salesgroups.filter((item, index) => {
        if (item.salesgroupdisplayTx == detail.salesgroupdisplayTx.value.trim()) return true;
      });
      if (selectedSalesgroupdisplayTx.length === 0) {
        detail.salesgroupdisplayTx.enable({ onlySelf: true });
        detail.salesgroupdisplayTx.markAsTouched({ onlySelf: true });
        errors = true;
        this.errorInfo = validation.message.salesgroups + rowmassegeTx;
        return;
      }
      if (detail.pricedispNr > validation.pricedispNr.maxNr) {
        this.errorInfo = validation.message.priceOver + validation.pricedispNr.maxNr.toString() + rowmassegeTx;
        return;
      }
      if (detail.bookDt.errors !== null) {
        detail.bookDt.enable({ onlySelf: true });
        detail.bookDt.markAsTouched({ onlySelf: true });
        errors = true;
      }
      if (detail.bookDt.value === null || detail.bookDt.value.length === 0) {
        detail.bookDt.enable({ onlySelf: true });
        detail.bookDt.markAsTouched({ onlySelf: true });
        errors = true;
        this.errorInfo = '発生日は' + validation.message.required + rowmassegeTx;
        return;
      }
      if (detail.ownerdisplayTx.errors !== null) {
        detail.ownerdisplayTx.enable({ onlySelf: true });
        detail.ownerdisplayTx.markAsTouched({ onlySelf: true });
        errors = true;
      }
      if (detail.salesgroupdisplayTx.errors !== null) {
        detail.salesgroupdisplayTx.enable({ onlySelf: true });
        detail.salesgroupdisplayTx.markAsTouched({ onlySelf: true });
        errors = true;
      }
      if (detail.pcsNr.value === null || detail.pcsNr.value.length === 0) {
        detail.pcsNr.enable({ onlySelf: true });
        detail.pcsNr.markAsTouched({ onlySelf: true });
        errors = true;
        this.errorInfo = '数量は' + validation.message.required + rowmassegeTx;
        return;
      }
      if (detail.pcsNr.errors !== null) {
        detail.pcsNr.enable({ onlySelf: true });
        detail.pcsNr.markAsTouched({ onlySelf: true });
        errors = true;
      }
      //SW-1872
      if (detail.UnitpricedispNrForm.errors !== null) {
        detail.UnitpricedispNrForm.enable({ onlySelf: true });
        detail.UnitpricedispNrForm.markAsTouched({ onlySelf: true });
        errors = true;
      }
      if (detail.expensememoTx.errors !== null) {
        detail.expensememoTx.enable({ onlySelf: true });
        detail.expensememoTx.markAsTouched({ onlySelf: true });
        errors = true;
      }
      if (errors) {
        return;
      }
    }
    let detailNum = this.details.length;
    const newDetail = new Detail(
      this.ownerService,
      this.salesGroupOwnerService,
      this.commonService,
      this.dialogsService,
      this.details[detailNum - 1].bookDt.value,
      this.details[detailNum - 1].ownerId,
      this.details[detailNum - 1].ownerdisplayTx.value,
      this.details[detailNum - 1].salesgroupId,
      this.details[detailNum - 1].salesgroupdisplayTx.value
    );
    newDetail.caller = this;
    this.details.push(newDetail);
  }

  ownerchange() {
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
      this.ownerTx = selectedOwner.ownerTx;
    }
    if (this.ownerResult && this.ownerId !== undefined) {
      this.allowner = false;
      this.salesGroupOwnerService
        .get()
        .then(outputJson => {
          this.working = false;
          if (this.ownerId !== undefined) {
            this.salectowners = outputJson.salesgroupowners.filter((item, index) => {
              if (item.ownerId == this.ownerId) return true;
            });
            this.ownerTx = this.salectowners[0] ? this.salectowners[0].ownerTx : this.ownerTx;
          }
        })
        .catch(error => {
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    } else {
      this.allowner = true;
    }
  }

  onSubmit() {
    let errors = false;
    let countNr = 0;
    let rowmassegeTx = '';
    for (const detail of this.details) {
      countNr += 1;
      rowmassegeTx = '(明細' + countNr.toString() + ')';
      var selectedOnwerdisplayTx = detail.owners.filter((item, index) => {
        if (item.ownerdisplayTx === detail.ownerdisplayTx.value.trim()) return true;
      });
      if (selectedOnwerdisplayTx.length === 0) {
        detail.ownerdisplayTx.enable({ onlySelf: true });
        detail.ownerdisplayTx.markAsTouched({ onlySelf: true });
        errors = true;
        this.errorInfo = validation.message.onwer + rowmassegeTx;
        return;
      }
      var selectedSalesgroupdisplayTx = detail.salesgroups.filter((item, index) => {
        if (item.salesgroupdisplayTx == detail.salesgroupdisplayTx.value.trim()) return true;
      });
      if (selectedSalesgroupdisplayTx.length === 0) {
        detail.salesgroupdisplayTx.enable({ onlySelf: true });
        detail.salesgroupdisplayTx.markAsTouched({ onlySelf: true });
        errors = true;
        this.errorInfo = validation.message.salesgroups + rowmassegeTx;
        return;
      }
      if (detail.pricedispNr > validation.pricedispNr.maxNr) {
        this.errorInfo = validation.message.priceOver + validation.pricedispNr.maxNr.toString() + rowmassegeTx;
        return;
      }
      if (detail.bookDt.errors !== null) {
        detail.bookDt.enable({ onlySelf: true });
        detail.bookDt.markAsTouched({ onlySelf: true });
        errors = true;
      }
      if (detail.bookDt.value === null || detail.bookDt.value.length === 0) {
        detail.bookDt.enable({ onlySelf: true });
        detail.bookDt.markAsTouched({ onlySelf: true });
        errors = true;
        this.errorInfo = '発生日は' + validation.message.required + rowmassegeTx;
        return;
      }
      if (detail.ownerdisplayTx.errors !== null) {
        detail.ownerdisplayTx.enable({ onlySelf: true });
        detail.ownerdisplayTx.markAsTouched({ onlySelf: true });
        errors = true;
      }
      if (detail.salesgroupdisplayTx.errors !== null) {
        detail.salesgroupdisplayTx.enable({ onlySelf: true });
        detail.salesgroupdisplayTx.markAsTouched({ onlySelf: true });
        errors = true;
      }
      if (detail.pcsNr.value === null || detail.pcsNr.value.length === 0) {
        detail.pcsNr.enable({ onlySelf: true });
        detail.pcsNr.markAsTouched({ onlySelf: true });
        errors = true;
        this.errorInfo = '数量は' + validation.message.required + rowmassegeTx;
        return;
      }
      if (detail.pcsNr.errors !== null) {
        detail.pcsNr.enable({ onlySelf: true });
        detail.pcsNr.markAsTouched({ onlySelf: true });
        errors = true;
      }
      if (detail.expensememoTx.errors !== null) {
        detail.expensememoTx.enable({ onlySelf: true });
        detail.expensememoTx.markAsTouched({ onlySelf: true });
        errors = true;
      }
      if (errors) {
        return;
      }
    }
    if (this.working) return;
    this.working = true;
    if (!errors) {
      const details = [];
      for (const det of this.details) {
        details.push(det.toJson());
      }
      this.expenseService
        .postAll({
          updprogramCd: 'wa8013',
          details: details
        })
        .then(outputJson => {
          sessionStorage.removeItem('details');
          this.closeButtonClick.emit(true);
          this.working = false;
        })
        .catch(error => {
          this.errorInfo = this.commonService.getErrorMessage(error);
          this.working = false;

          setTimeout(() => {
            this.scrollContent.nativeElement.scrollTop = 0;
          }, 200);
        });
    }
  }

  ngOnChanges() {
    if (this.ownerchanges) {
      this.ownerchange();
    }

    if (this.isShow) {
      this.isDelayHide = false;
      this.errorInfo = '';
      this.initDatas();
    } else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.onSubmitActive = 'disabled';
    this.details = [new Detail(this.ownerService, this.salesGroupOwnerService, this.commonService, this.dialogsService)];
    this.details.forEach(v => {
      v.caller = this;
    });
  }

  ngDoCheck() {
    if (!this.isShow) return;

    //open状態でのみチェック
    for (const detail of this.details) {
      if (detail.bookDt.value) detail.bookDtActive = 'active';

      if (detail.pcsNr.errors != null)
        detail.pcsNrActive = 'error';
      else if ((detail.pcsNr.value + '').length > 0) detail.pcsNrActive = 'active';
      else detail.pcsNrActive = '';
      //SW-1872
      if (detail.UnitpricedispNrForm.errors != null)
        detail.unitpricedispNrActive = 'error';
      else if ((detail.pcsNr.value + '').length > 0) detail.unitpricedispNrActive = 'active';
      else detail.unitpricedispNrActive = '';

      if (detail.ownerdisplayTx.value) {
        if (detail.assignOwnerId != null) detail.ownerdisplayTxActive = 'active';
        detail.salesgroupdisplayTxActive = '';
      }
      if (detail.salesgroupdisplayTx.value) detail.salesgroupdisplayTxActive = 'active';

      if ((detail.expensememoTx.value).length > 0) detail.expensememoTxActive = 'active';
      else if (detail.expensememoTx.errors != null) detail.expensememoTxActive = 'error';
      else detail.expensememoTxActive = '';

      if (
        detail.bookDt.errors == null &&
        detail.ownerdisplayTx.errors == null &&
        detail.salesgroupdisplayTx.errors == null &&
        detail.pcsNr.errors == null &&
        detail.expensememoTx.errors == null
      ) {
        if (detail.bookDt.value && detail.pcsNrActive === 'active') {
          this.onSubmitActive = 'active';
        } else this.onSubmitActive = 'disabled';
      }
      else
        this.onSubmitActive = 'disabled';
    }
  }

  cancel() {
    sessionStorage.removeItem('details');
    this.closeButtonClick.emit(false);
    sessionStorage.setItem('isShowOwnerSelect', 'true');
    this.errorInfo = '';
  }
}

class Detail {
  // drop down list
  public owners: any;
  public salesgroups: any;
  public salesgroupowners: any;
  public allsalesgroupowners: any;
  //
  public bookDt: FormControl;
  public ownerId: number;
  public ownerdisplayTx: FormControl;
  public salesgroupId: number;
  public salesgroupdisplayTx: FormControl;
  public salesgroupunitTx: string;
  public unitpricedispNr: number;
  public pcsNr: FormControl;
  //SW-1872
  public UnitpricedispNrForm: FormControl;
  public typetaxCd: string;
  public typetaxTx: string;
  public pricedispNr: number;
  public rawPricedispNr: number;
  public expensememoTx: FormControl;

  public ownerdisplayTxList = new Array();
  public filteredOwnerOptions: Observable<string[]>;
  public filteredSalesgroupOptions: Observable<string[]>;

  public bookDtActive;
  public ownerdisplayTxActive;
  public salesgroupdisplayTxActive = 'disabled';
  public pcsNrActive;
  public unitpricedispNrActive;
  public expensememoTxActive;

  public bookDtCls = '';
  public ownerdisplayTxCls = '';
  public salesgroupdisplayTxCls = 'disabled';
  public pcsNrCls = '';
  public expensememoTxCls = '';

  //validation check
  public ownerdisplayTxs = [];
  public assignOwnerId = null;
  public errorInfo = '';
  public caller = null;

  constructor(
    private ownerService: OwnerService,
    private salesGroupOwnerService: SalesGroupOwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private selectedbookDt?: string,
    private selectedOwnerId?: number,
    private selectedOwnerdisplayTx?: string,
    private selectedSalesgroupId?: number,
    private selectedsalesgroupdisplayTx?: string
  ) {
    // Define each input element (initial value and validation rule)
    if (selectedbookDt !== undefined) {
      this.bookDt = new FormControl(selectedbookDt);
      Validators.required;
    } else {
      this.bookDt = new FormControl('', [Validators.required]);
    }

    this.ownerdisplayTx = new FormControl('', Validators.required);

    this.salesgroupdisplayTx = new FormControl('', Validators.required);

    this.pcsNr = new FormControl('', [
      Validators.pattern(validation.decimal_3),
      Validators.pattern(validation.exclude0),
      Validators.max(validation.pcsNr.maxNr),
      Validators.min(validation.pcsNr.minNr)
    ]);
    //SW-1872
    this.UnitpricedispNrForm = new FormControl('', [
      Validators.pattern(validation.decimal_2),
      Validators.max(99999999.99),
      Validators.min(-99999999.99)
    ]);

    this.expensememoTx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.expensememoTx.maxLength)
    ]);

    var ownerResult = sessionStorage.getItem('ownerResult');
    var ownerJSON = ownerResult == null ? null : JSON.parse(ownerResult);

    if (ownerJSON != null && ownerJSON.ownerId !== undefined) {
      this.assignOwnerId = ownerJSON.ownerdisplayTx;
      this.ownerdisplayTxActive = 'disabled';
      this.ownerdisplayTx.disable();
    } else {
      this.assignOwnerId = null;
      this.ownerdisplayTxActive = '';
      this.ownerdisplayTx.enable();
    }

    this.ownerService
      .get()
      .then(outputJson => {
        this.owners = outputJson.owners;
        if (selectedOwnerdisplayTx !== undefined) {
          this.ownerId = this.selectedOwnerId;
          this.ownerdisplayTx.setValue(this.selectedOwnerdisplayTx);
        }
        this.salesGroupOwnerService
          .get()
          .then(outputJson => {
            // 単価が定義された売上分類のみ取得するため、売上分類ではなく、荷主別売上分類を利用する
            this.allsalesgroupowners = outputJson.salesgroupowners;
            this.salesgroups = this.getSalesgroupowners();
            this.salesgroupowners = this.getSalesgroupowners();
            this.filteredOwnerOptions = this.ownerdisplayTx.valueChanges.startWith(null).map(val => (val ? this.ownerFilter(val) : this.owners));
            this.filteredSalesgroupOptions = this.salesgroupdisplayTx.valueChanges.startWith(null).map(val => (val ? this.salesgroupFilter(val) : this.salesgroupowners));
            if (this.assignOwnerId != null) this.ownerdisplayTx.setValue(this.assignOwnerId);
            this.changeOwner('');
          })
          .catch(error => {
            // this.dialogsService.info('エラー', this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);

          });
      })
      .catch(error => {
        // this.dialogsService.info('エラー', this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ownerFilter(val: string): string[] {
    return this.owners;
  }

  salesgroupFilter(val: string): string[] {
    this.ownerId = this.getOwnerId();
    this.salesgroupowners = this.getSalesgroupowners();
    if (this.salesgroupowners !== undefined) {
      return this.salesgroupowners;
    }
  }

  changeOwner(event: string) {
    this.caller.errorInfo = '';

    this.ownerId = this.getOwnerId();
    this.salesgroups = this.getSalesgroupowners();
    this.salesgroupowners = this.getSalesgroupowners();
    this.salesgroupId = undefined;
    this.salesgroupdisplayTx.setValue('');
  }

  changeSalesgroup(event: number) {
    this.caller.errorInfo = '';

    this.salesgroupId = this.getSalesgroupId();
    //SW-1872　項目選択時に単価セット
    this.unitpricedispNr = this.getUnitpricedispNr();
    this.UnitpricedispNrForm.setValue(this.unitpricedispNr);
  }

  clrErr() {
    this.caller.errorInfo = '';
  }

  getOwnerId(): number {
    if (this.owners !== undefined && this.ownerdisplayTx.value.trim() !== '') {
      var selectedOwners = this.owners.filter((item, index) => {
        if (item.ownerdisplayTx === this.ownerdisplayTx.value.trim()) return true;
      });
      if (selectedOwners.length > 0) {
        return selectedOwners[0]['ownerId'];
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }

  getSalesgroupId(): number {
    this.salesgroups = this.getSalesgroupowners();
    if (this.salesgroups !== undefined && this.salesgroupdisplayTx.value.trim() !== '') {
      var selectedSalesgroups = this.salesgroups.filter((item, index) => {
        if (item.salesgroupdisplayTx === this.salesgroupdisplayTx.value.trim()) return true;
      });
      if (selectedSalesgroups.length > 0) {
        return selectedSalesgroups[0]['salesgroupId'];
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }

  getSalesgroupowners(): any[] {
    if (this.ownerId !== undefined && this.allsalesgroupowners !== undefined) {
      var salesgroupowners = this.allsalesgroupowners.filter((item, index) => {
        if (item.ownerId === this.ownerId) return true;
      });
    }
    return salesgroupowners;
  }

  getSalesgroupunitTx(): string {
    if (this.salesgroups !== undefined && this.salesgroupId !== undefined) {
      var selectedSalesgroups = this.salesgroups.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      if (selectedSalesgroups.length > 0) {
        return selectedSalesgroups[0]['salesgroupunitTx'];
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }

  getUnitpricedispNr(): number {
    if (this.salesgroupowners !== undefined && this.salesgroupId !== undefined) {
      var salesgroupowner = this.salesgroupowners.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      if (salesgroupowner.length > 0) {
        this.unitpricedispNr = salesgroupowner[0]['unitpricedispNr'];
        return this.unitpricedispNr;
      } else {
        return 0;
      }
    } else {
      return undefined;
    }
  }

  getTypetaxTx(): string {
    if (this.salesgroups !== undefined && this.salesgroupId !== undefined) {
      var salesgroupowner = this.salesgroupowners.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      if (salesgroupowner.length > 0) {
        this.typetaxCd = salesgroupowner[0]['typetaxCd'];
        return salesgroupowner[0]['typetaxTx'];
      } else {
        this.typetaxCd = undefined;
        return undefined;
      }
    } else {
      this.typetaxCd = undefined;
      return undefined;
    }
  }

  getPricedispNr(): number {
    if (this.salesgroupowners !== undefined && this.salesgroupId !== undefined) {
      var salesgroupowner = this.salesgroupowners.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      if (salesgroupowner.length > 0) {
        var tmpPricedispNr = this.UnitpricedispNrForm.value * this.pcsNr.value;
        this.rawPricedispNr = tmpPricedispNr;
        this.pricedispNr = Math.round(Math.abs(tmpPricedispNr)) * ((tmpPricedispNr < 0) ? -1 : 1 );
        return this.pricedispNr;
      } else {
        return 0;
      }
    } else {
      return undefined;
    }
  }

  toJson(): object {
    const bookDate = new Date(this.bookDt.value);
    return {
      ownerId: this.ownerId,
      bookDt: this.bookDt.value,
      bookyearmonthTx: bookDate.getFullYear() + ('0' + (bookDate.getMonth() + 1)).slice(-2),
      salesgroupId: +this.salesgroupId,
      unitpricedispNr: this.UnitpricedispNrForm.value,
      pcsNr: this.pcsNr.value,
      pricedispNr: this.rawPricedispNr,
      typetaxCd: this.typetaxCd,
      expensetaxNr: 0,
      expensememoTx: this.expensememoTx.value
    };
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa8Billing/wa8013/wa8013.component.ts